import React, { Component } from 'react';
import './index.css';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

class Buttons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
    }



    render() {
        return (
            <div>
                {!this.props.modal && (
                    <div>
                        <Link
                            className={`btn btn-danger buttonColor buttonFont text-white customBorderRadius quattrocentosans regular ${this.props.type || ''}`}
                            to={`/${this.props.link || ''}`}
                        >
                            {this.props.name}
                        </Link>
                    </div>
                )}
            </div>
        );
    }
}

Buttons.propTypes = {
    modal: PropTypes.bool,
    type: PropTypes.string,
    link: PropTypes.string,
    name: PropTypes.string.isRequired
};

export default withRouter(Buttons);


// WEBPACK FOOTER //
// ./src/_components/common/Button/index.jsx